import React from 'react'

interface FileMetricsRowProps {
  recordCount: number
  lastLoaded: string
  slaStatusBadge: string
  slaStatusLabel: string
  sourceImpactBadge: string
  sourceImpactLabel: string
}

const FileMetricsRow: React.FC<FileMetricsRowProps> = ({
  recordCount,
  lastLoaded,
  slaStatusBadge,
  slaStatusLabel
}) => {
  return (
    <div className="metrics-row-grid">
      <div className="metric-row-item">
        <div className="metric-row-label">Record Count</div>
        <div className="metric-row-value">{recordCount.toLocaleString()}</div>
      </div>
      <div className="metric-row-item">
        <div className="metric-row-label">Last Loaded</div>
        <div className="metric-row-value">{lastLoaded}</div>
      </div>
      <div className="metric-row-item">
        <div className="metric-row-label">SLA Status</div>
        <div className="metric-row-value">
          <span className={`sla-badge ${slaStatusBadge}`}>{slaStatusLabel}</span>
        </div>
      </div>
      
    </div>
  )
}

export default FileMetricsRow
